import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import { 
  FaHome, 
  FaUsers, 
  FaFilter, 
  FaUserCog, 
  FaSignOutAlt, 
  FaUser,
  FaBars,
  FaUserShield
} from 'react-icons/fa';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [userRole, setUserRole] = useState('user');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const savedState = localStorage.getItem('navbarOpen');
        setIsOpen(savedState === 'true');
        
        // Get user role from localStorage
        const userDataString = localStorage.getItem('userData');
        if (userDataString) {
            try {
                const userData = JSON.parse(userDataString);
                setUserRole(userData.role || 'user');
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }
    }, []);

    const handleToggle = () => {
        setIsOpen(!isOpen);
        localStorage.setItem('navbarOpen', !isOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        alert('Logged out successfully!');
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <div className={`navbar-container ${isOpen ? 'open' : ''}`}>
            <button className="toggle-button" onClick={handleToggle}>
                <FaBars />
            </button>
            <nav className="navbar">
                <ul className="navbar-links">
                    <li>
                        <Link to="/landing" className={isActive('/landing') ? 'active' : ''}>
                            <FaHome className="icon" />
                            {isOpen && <span>Dashboard</span>}
                        </Link>
                    </li>
                    <li>
                        <Link to="/customers" className={isActive('/customers') ? 'active' : ''}>
                            <FaUsers className="icon" />
                            {isOpen && <span>Customers</span>}
                        </Link>
                    </li>
                    <li>
                        <Link to="/filters" className={isActive('/filters') ? 'active' : ''}>
                            <FaFilter className="icon" />
                            {isOpen && <span>Filters</span>}
                        </Link>
                    </li>
                    <li>
                        <Link to="/customers-filters" className={isActive('/customers-filters') ? 'active' : ''}>
                            <FaUserCog className="icon" />
                            {isOpen && <span>Customer Filters</span>}
                        </Link>
                    </li>
                    {userRole === 'admin' && (
                        <li>
                            <Link to="/users" className={isActive('/users') ? 'active' : ''}>
                                <FaUserShield className="icon" />
                                {isOpen && <span>Users</span>}
                            </Link>
                        </li>
                    )}
                </ul>
                <div className="navbar-bottom">
                    <Link to="/profile" className={`user-link ${isActive('/profile') ? 'active' : ''}`}>
                        <FaUser className="icon" />
                        {isOpen && <span>Profile</span>}
                    </Link>
                    <button onClick={handleLogout} className="logout-button">
                        <FaSignOutAlt className="icon" />
                        {isOpen && <span>Logout</span>}
                    </button>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
